import { styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';
import { SLIDE_CLASSNAME } from '../constants';
import { getNavigationArrowWidth } from '../utils';
export const CarouselRoot = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(({
  isTouchActive,
  navigation,
  width
}) => ({
  padding: navigation?.showArrows && navigation.position === 'outside' ? `0 ${getNavigationArrowWidth({
    size: navigation.size
  })}px` : 0,
  position: 'relative',
  width,
  '&:hover .active-pagination-step': {
    animation: 'none'
  },
  ...(isTouchActive ? {
    '.active-pagination-step': {
      animation: 'none'
    }
  } : null),
  '.keen-slider:not([data-keen-slider-disabled])': {
    alignContent: 'flex-start',
    display: 'flex',
    KhtmlUserSelect: 'none',
    msTouchAction: 'pan-y',
    overflow: 'hidden',
    position: 'relative',
    touchAction: 'pan-y',
    userSelect: 'none',
    WebkitTapHighlightColor: 'transparent',
    WebkitTouchCallout: 'none',
    width: '100%',
    [`.${SLIDE_CLASSNAME}`]: {
      minHeight: '100%',
      overflow: 'hidden',
      position: 'relative',
      width: '100%'
    },
    '&[data-keen-slider-reverse]': {
      flexDirection: 'row-reverse'
    },
    '&[data-keen-slider-v]': {
      flexWrap: 'wrap'
    }
  }
}));
export const CarouselInner = styled('div')({
  cursor: 'grab',
  '&:active': {
    cursor: 'grabbing'
  }
});
export const CarouselSlideRoot = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(({
  minWidth
}) => ({
  maxWidth: 'fit-content',
  minWidth
}));
//# sourceMappingURL=root.js.map